<section class="content">

    <div class="container-fluid">

        <div class="block-header">
            <div class="row">

                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">




                    <ul class="breadcrumb">
                        <li class="breadcrumb-item">
                            <h4 class="page-title">{{title}}</h4>

                        </li>

                        &nbsp;
                        <span (click)="goToDashboard()" style="cursor: pointer;">
              <i class="fas fa-home" style="color: blue;"></i></span>&nbsp; &nbsp;


                        <li class="breadcrumb-item " *ngIf="breadcrumbs?.childBreadcrumb"><a (click)="check_url(breadcrumbs?.childBreadcrumburl)">{{breadcrumbs?.childBreadcrumb}} </a></li>
                        <li class="breadcrumb-item bcrumb-1" *ngIf="breadcrumbs?.childBreadcrumb1"><a class="cursor-pointer" (click)="check_url(breadcrumbs?.childBreadcrumb1url,breadcrumbs?.childBreadcrumb1)">{{breadcrumbs?.childBreadcrumb1}}</a>
                        </li>
                        <li class="breadcrumb-item bcrumb-1" *ngIf="breadcrumbs?.childBreadcrumb2"><a class="cursor-pointer" (click)="check_url(breadcrumbs?.childBreadcrumb2url,breadcrumbs?.childBreadcrumb2)">{{breadcrumbs?.childBreadcrumb2}}</a>
                        </li>
                        <li class="breadcrumb-item bcrumb-1" *ngIf="breadcrumbs?.childBreadcrumb3"><a class="cursor-pointer" (click)="check_url(breadcrumbs?.childBreadcrumb3url,breadcrumbs?.childBreadcrumb3)">{{breadcrumbs?.childBreadcrumb3}}</a>
                        </li>
                        <li class="breadcrumb-item bcrumb-1" *ngIf="breadcrumbs?.childBreadcrumb4"><a class="cursor-pointer" (click)="check_url(breadcrumbs?.childBreadcrumb4url,breadcrumbs?.childBreadcrumb4)">{{breadcrumbs?.childBreadcrumb4}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

</section>